import { Component, Input, Output, OnChanges, EventEmitter, SimpleChanges, ElementRef, OnInit, OnDestroy } from '@angular/core';


import { UserFormService } from '../user-form/user-form.service';

@Component({
    selector: 'user-date',
    templateUrl: './user-date.component.html',
    styleUrls: ['./user-date.component.css']
})
export class UserDateComponent {
    @Input() value: any;
    @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();
    @Input() label: string;
    @Input() required: boolean = false;
    @Input() disabled: boolean = false;
    @Input('show-time') showTime: boolean = false;
    model: any;
    @Input() placeholder: string = "Angiv dato";
    firstRun: boolean = false;
    previousEmitModel: any;

    pickerOptions = {
        dateFormat: 'dd-mm-yyyy'
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.value) {
            if (this.value !== undefined && this.value !== "" && this.value !== null) {
                var d = new Date(this.value);
                this.model = { date: { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() } };

                if (this.firstRun) {
                    this.firstRun = false;
                    setTimeout(() => {
                        this.valueChanged(true);
                    });
                }
            }
        }
    }

    constructor(private eleRef: ElementRef, private service?: UserFormService) {
    }

    isValid() {
        return true;
    }

    controlTouched() {
        return true;
    }

    valueChanged(firstRun: boolean = false) {

        if (this.model && this.model.date) {

            if (!this.modelsIsEqual()) {
                this.previousEmitModel = this.getStringDate(this.model);

                if (!firstRun) {
                    this.valueChange.emit(this.previousEmitModel);

                    if (this.service) {
                        this.service.inputChanged.emit(this.previousEmitModel);
                    }
                }
            }
        }
        else {
            if (this.previousEmitModel && !firstRun) {
                this.valueChange.emit(undefined);
                this.previousEmitModel = undefined;
            }
        }
    }

    pad(num: number): string {
        return num < 10 ? "0" + num : num.toString();
    }

    getStringDate(model: any) {
        if (!model || !model.date)
            return undefined;

        return model.date.year + "-" + this.pad(model.date.month) + "-" + this.pad(model.date.day) + "T00:00:00Z";
    }

    modelsIsEqual() {
        return this.previousEmitModel === this.getStringDate(this.model);
    }


}
